<template>
    <group-details :groupId="props.groupId">
        <snippet-list :groupId="props.groupId" readOnly withoutOverview class="col-span-12 lg:col-span-10"></snippet-list>
    </group-details>
</template>

<script setup>
import GroupDetails from './GroupDetails.vue';
import SnippetList from '~/components/snippets/SnippetList.vue';

const props = defineProps({
    groupId: {
        type: String,
        required: false,
    },
});

</script>
